/*eslint no-unused-vars: "off"*/
import React, { useEffect } from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import "./index.css";
// Set up translations before any component renders
import "./i18n";
import reportWebVitals from "./reportWebVitals";

// React Date Picker CSS
import "react-date-range/dist/styles.css"; // main style file
import "react-date-range/dist/theme/default.css"; // theme css file

// Run config functions (just import)
// import axiosConfig from "./config/axios";

import { Honeybadger, HoneybadgerErrorBoundary } from "@honeybadger-io/react";

// Redux
import store from "./store";

// Stripe
import { loadStripe } from "@stripe/stripe-js";
import stripeConfig from "./config/stripe";
import { Elements } from "@stripe/react-stripe-js";
import flash from "./services/flash";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import defaultQueryFunction from "./defaultQueryFunction";
import {
  ConfigCatProvider,
  PollingMode,
  useConfigCatClient,
} from "configcat-react";
import AxiosService from "./services/axios/AxiosContext";
import AuthenticationManager2 from "./AuthenticationManager2";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      queryFn: defaultQueryFunction,
    },
  },
});
const stripePromise = loadStripe(stripeConfig.publicKey);

// Honeybadger:
const honeybadger = Honeybadger.configure({
  apiKey: "hbp_J85WpZnMMcBPNjehAvMnDBtlq4jv6Z0YcTqS",
  environment: process.env.REACT_APP_ENVIRONMENT ?? "development",
});
flash.clear();

// Dev tools component to expose ConfigCat refresh in browser console
function DevToolsInit() {
  const configcatClient = useConfigCatClient();

  useEffect(() => {
    window.devRefreshFeatureFlags = async () => {
      console.log("🔄 Refreshing ConfigCat feature flags...");
      await configcatClient.forceRefreshAsync();
      console.log("✅ Feature flags refreshed!");
    };
    return () => {
      delete window.devRefreshFeatureFlags;
    };
  }, [configcatClient]);

  return null;
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ConfigCatProvider
      sdkKey={
        process.env.REACT_APP_CONFIG_CAT_KEY ??
        "qhLcCAAOek-LKNMcLhm-ig/SYOhi7Arak2L1yJiFj_5Zg"
      }
      pollingMode={PollingMode.AutoPoll}
      options={{ pollIntervalSeconds: 300 }}
    >
      <DevToolsInit />
      <AxiosService>
        <QueryClientProvider client={queryClient}>
          <Provider store={store}>
            <Elements stripe={stripePromise}>
              <HoneybadgerErrorBoundary honeybadger={honeybadger}>
                <AuthenticationManager2 />
              </HoneybadgerErrorBoundary>
            </Elements>
          </Provider>
        </QueryClientProvider>
        <div className="flex mt-0 justify-center items-center">
          <div id="recaptcha-container"></div>
        </div>
      </AxiosService>
    </ConfigCatProvider>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
